<template>
    <div>
        <div>
            <Table :columns="tblColumns" :data="tblData" size="small" :loading="isLoading" class="requestsList" />
        </div>
        <Page
            :total="totalCount"
            :current="currentPage"
            :page-size="limit"
            class="pagination"
            @on-change="handleOnpageChanged"
        />
        <ViewProjectLogDisputeModal ref="ViewRequest" @reload="handleReloadList" />
        <UpdateProjectLogDisputeModal ref="UpdateRequest" @reload="handleReloadList" />
        <DeleteRequestModal ref="DeleteRequest" @create="handleReloadList" />
    </div>
</template>

<script>
import moment from 'moment';
import ViewProjectLogDisputeModal from '@/components/Requests/Dev/ProjectLogDispute/ViewProjectLogDisputeModal';
import UpdateProjectLogDisputeModal from '@/components/Requests/Dev/ProjectLogDispute/UpdateProjectLogDisputeModal';
import DeleteRequestModal from '@/components/Requests/Dev/TimeDispute/DeleteRequestModal';

export default {
    components: {
        ViewProjectLogDisputeModal,
        UpdateProjectLogDisputeModal,
        DeleteRequestModal,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        requestsDataList: {
            type: Array,
            default: () => [],
        },
        currentPage: {
            type: Number,
            default: 0,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        limit: {
            type: Number,
            default: 0,
        },
        totalPerPage: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            tblColumns: [
                {
                    title: 'Date Submitted',
                    key: 'createdAt',
                    width: 100,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.createdAt ? moment(params.row.createdAt).utc().format('YYYY-MM-DD') : ''
                        );
                    },
                },
                {
                    title: 'Timelog Date',
                    key: 'createdAt',
                    width: 100,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.requestedStart
                                ? moment(params.row.requestedStart).utc().format('YYYY-MM-DD')
                                : ''
                        );
                    },
                },
                {
                    title: 'Project',
                    key: 'project',
                    width: 150,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.currentData && params.row.currentData.project
                                ? params.row.currentData.project.name
                                : '-'
                        );
                    },
                },
                {
                    title: 'Initial Time',
                    key: 'initialTime',
                    width: 180,
                    render: (h, params) => {
                        return params.row.currentData
                            ? h(
                                  'div',
                                  `${moment(params.row.currentData.startTime).utc().format('hh:mm A')} - ${moment(
                                      params.row.currentData.endTime
                                  )
                                      .utc()
                                      .format('hh:mm A')}`
                              )
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Requested Time',
                    key: 'requestedTime',
                    width: 180,
                    render: (h, params) => {
                        return params.row.requestedStart
                            ? h(
                                  'div',
                                  `${moment(params.row.requestedStart).utc().format('hh:mm A')} - ${moment(
                                      params.row.requestedEnd
                                  )
                                      .utc()
                                      .format('hh:mm A')}`
                              )
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Initial Hours',
                    key: 'initialHrs',
                    width: 120,
                    render: (h, params) => {
                        return params.row.currentData && params.row.currentData.elapsedTimeInHrs
                            ? h('div', Number(params.row.currentData.elapsedTimeInHrs).toFixed(2) + ' hours')
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Requested Hours',
                    key: 'requestedHrs',
                    width: 120,
                    render: (h, params) => {
                        return params.row.requestedData && params.row.requestedData.elapsedTimeInHrs
                            ? h('div', Number(params.row.requestedData.elapsedTimeInHrs).toFixed(2) + ' hours')
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Status',
                    key: 'status',
                    minWidth: 100,
                    render: (h, params) => {
                        const status = params.row.status;
                        let label = '',
                            className = 'statusLabel';
                        const upperCaseStats = status.toString().toUpperCase();
                        switch (status.toString().trim()) {
                            case 'pending':
                                label = upperCaseStats;
                                className = `${className} warning`;
                                break;
                            case 'rejected':
                                label = upperCaseStats;
                                className = `${className} danger`;
                                break;
                            case 'approved':
                                label = upperCaseStats;
                                className = `${className} success`;
                                break;
                            case 'cancelled':
                                label = upperCaseStats;
                                className = `${className} primary`;
                                break;
                            default:
                                break;
                        }
                        return h(
                            'div',
                            {
                                class: `${className}`,
                            },
                            label
                        );
                    },
                },
                {
                    title: 'Actions',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Tooltip', { props: { placement: 'top', content: 'View' } }, [
                                h(
                                    'Button',
                                    {
                                        class: 'pt-btn-3',
                                        on: {
                                            click: () => {
                                                this.$refs.ViewRequest.openModal(params.row);
                                            },
                                        },
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-eye',
                                                size: '25',
                                            },
                                        }),
                                    ]
                                ),
                            ]),
                            h('Tooltip', { props: { placement: 'top', content: 'Edit' } }, [
                                h(
                                    'Button',
                                    {
                                        class: `${
                                            params.row.status && params.row.status.includes('pending')
                                                ? 'pt-btn-6'
                                                : 'pt-btn-6 btn-disable'
                                        }`,
                                        on: {
                                            click: () => {
                                                this.$refs.UpdateRequest.openModal(params.row);
                                            },
                                        },
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-create',
                                                size: '25',
                                            },
                                        }),
                                    ]
                                ),
                            ]),
                            h('Tooltip', { props: { placement: 'top', content: 'Delete' } }, [
                                h(
                                    'Button',
                                    {
                                        class: `${
                                            params.row.status && params.row.status.includes('pending')
                                                ? 'pt-btn-1'
                                                : 'pt-btn-1 btn-disable'
                                        }`,
                                        on: {
                                            click: () => {
                                                this.$refs.DeleteRequest.openModal(params.row, 'delete');
                                            },
                                        },
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-trash',
                                                size: '25',
                                            },
                                        }),
                                    ]
                                ),
                            ]),
                        ]);
                    },
                },
            ],
            tblData: [],
        };
    },

    watch: {
        requestsDataList(data) {
            this.tblData = data;
        },
    },
    methods: {
        handleReloadList() {
            this.$emit('reload');
        },
        handleOnpageChanged(page) {
            this.$emit('on-page-change', page);
        },
    },
};
</script>

<style lang="scss">
ul.pagination.ivu-page {
    text-align: end;
}
.requestsList button {
    width: 25px;
    margin-left: 10px;
}
.requestsList i.ivu-icon {
    margin-left: -12.5px;
}
.btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
}
.statusLabel {
    display: inline-block;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
    vertical-align: middle;
    max-width: 250px;
    padding: 5px;
    text-align: center;
}
.success {
    background: #49e97e;
    font-weight: bold;
}
.warning {
    background: #ffc107;
    font-weight: bold;
}
.danger {
    background: #e9495d;
    font-weight: bold;
}
.primary {
    background: #211841;
}
</style>
